import { Spinner } from '@/components/ui/spinner'
import { useAuth } from '@/hooks/use-auth'
import { RequireAuth } from '@/components/auth/RequireAuth'
import { SoftIdentityGate } from '@/components/auth/SoftIdentityGate'

/**
 * Requires a signed-in user with identity verification completed.
 * Soft-gates (inline card) instead of hard-redirecting — user starts Sumsub via the verify modal.
 */
export function RequireVerified({ children }: { children: React.ReactNode }) {
  const { profile, isLoading } = useAuth()

  return (
    <RequireAuth>
      {isLoading || !profile ? (
        <div className="flex min-h-[40vh] items-center justify-center">
          <Spinner />
        </div>
      ) : profile.isIdentityVerified ? (
        <>{children}</>
      ) : (
        <SoftIdentityGate />
      )}
    </RequireAuth>
  )
}
